{
  "share": {
    "subject": "Join the «{{title}}» event on Agapella",
    "message": "Join the «{{title}}» event on Agapella\n{{url}}"
  },
  "types": {
    "retreat": "RETREAT",
    "workshop": "WORKSHOP",
    "ceremony": "CEREMONY",
    "class": "CLASS",
    "festival": "FESTIVAL",
    "meetup": "MEETUP",
    "practice": "PRACTICE"
  },
  "source": {
    "all": "All",
    "agape": "Agapē",
    "masters": "Masters"
  },
  "formatGroup": {
    "live": "Live",
    "events": "Events"
  },
  "format": {
    "live_meditation": "Live Meditation",
    "guided_practice": "Guided Practice",
    "breathwork": "Breathwork Session",
    "movement": "Movement Class",
    "somatic": "Somatic Practice",
    "sound_bath": "Sound Bath",
    "mantra": "Mantra & Voice",
    "mindfulness": "Mindfulness Session",
    "coaching_group": "Coaching Session",
    "talk": "Talk / Teaching",
    "qa": "Q&A / AMA",
    "community_circle": "Community Circle",
    "deep_dive": "Deep Dive",
    "morning_ritual": "Morning Ritual",
    "evening_winddown": "Evening Wind-Down",
    "workshop": "Workshop",
    "masterclass": "Masterclass",
    "intensive": "Intensive",
    "live_series": "Live Session Series",
    "course_cohort": "Course Cohort",
    "retreat_online": "Retreat (Online)",
    "retreat_inperson": "Retreat (In-person)",
    "immersion": "Immersion / Camp",
    "challenge": "Challenge",
    "ceremony": "Ceremony / Circle",
    "sound_journey": "Sound Journey",
    "experience_night": "Experience Night",
    "meetup": "Meetup (Local)",
    "private_1on1": "1:1 Session",
    "festival": "Festival / Summit",
    "facilitator_training": "Training for Facilitators",
    "certification": "Certification Program"
  },
  "pathGroup": {
    "science": "Science & Psychology",
    "body": "Body & Somatic",
    "spiritual": "Spiritual"
  },
  "path": {
    "mbsr": "Evidence-based Mindfulness",
    "stress_reset": "Stress & Burnout Reset",
    "anxiety": "Anxiety Regulation",
    "sleep": "Sleep & Recovery",
    "focus": "Focus & Productivity",
    "emotional_reg": "Emotional Regulation",
    "self_compassion": "Self-Compassion",
    "cbt": "CBT-inspired Practices",
    "somatic_psych": "Somatic Psychology",
    "nervous_system": "Nervous System",
    "trauma_sensitive": "Trauma-Sensitive",
    "mental_fitness": "Mental Fitness",
    "somatic_release": "Somatic Release",
    "breath_modern": "Breath & CO₂ Tolerance",
    "vagus_toning": "Vagus / Toning",
    "mobility": "Mobility & Stretch",
    "yin_relax": "Yin / Deep Relax",
    "movement_med": "Movement Meditation",
    "qigong": "Qigong / Tai Chi",
    "posture": "Posture & Presence",
    "grounding": "Grounding & Embodiment",
    "bioenergetic": "Bioenergetic / Shake",
    "heart_practice": "Heart Practice",
    "awareness": "Awareness & Presence",
    "intuition": "Intuition & Inner Guidance",
    "energy": "Energy Practice",
    "chakras": "Chakras",
    "sound_vibration": "Sound & Vibration",
    "ritual": "Ritual & Symbolic",
    "nature": "Nature / Earth Connection",
    "manifestation": "Manifestation & Intention",
    "shadow_work": "Shadow Work"
  },
  "traditions": {
    "all": "All Traditions",
    "buddhism": "Buddhism",
    "hinduism": "Hinduism",
    "sufism": "Sufism",
    "shaivism": "Shaivism",
    "yoga": "Yoga",
    "taoism": "Taoism",
    "mindfulness": "Mindfulness",
    "tantra": "Tantra"
  },
  "filter": {
    "sessionType": "Session Type",
    "eventType": "Event Type",
    "pathStyle": "Path & Style",
    "clearAll": "Clear all",
    "selectedCount": "{{count}} selected"
  }
}
